/** @jsxImportSource @emotion/react */

// import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { gameProviderJson } from "constants/desktop-game";
import { PATH } from "constants/path";
// import { QueryKeys } from "constants/queryKeys";
// import handleLoginGame from "helpers/handleLoginGame";
import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import DropdownMenu from "./DropdownMenu";
import { MainMenuStyle } from "./index.style";
import { ItemMenu, listMenu } from "./list-menu";

const menuNames: Record<string, string> = {
  "LIVE CASINO": "真人娛樂",
  SLOT: "電子游戲",
  CHESS: "棋牌游戲",
  SPORTS: "體育賽事",
  "FISH GAME": "捕魚街機",
  LOTTERY: "彩票游戲",
  RANKING: "排行榜",
  "24h SERVICE": "聯係客服",
  PROMOTION: "優惠活動",
};

function MainMenu() {
    // const { data: username } = useQuery<string>([QueryKeys.username]);
  const navigate = useNavigate();
  const [activeCode, setActiveCode] = useState<string | undefined>();

  const onClickItem = (item: ItemMenu) => {
    if (item.name === "RANKING") {
      return navigate(item.path);
    }
    if (item.isPopup) {
      window.open(
        item.path,
        "modal",
        `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1100,height=1200,left=-500,top=100`
      );
      return;
    }
    if (item.code && item.code.includes("#")) return;

    handleClickMenu(item);
  };
  const handleClickMenu = (item: ItemMenu) => {
    const games = gameProviderJson[item.code + ""];
    if (item.isSubGame) {
      return window.open(`/${item.code}/${games[0].provider_code}`);
    }
    if (!games?.length) {
      message.error({
        key: "Game",
        content: "遊戲維護中，請稍後再試！",
      });
      return;
    }
    // handleLoginGame(games[0], username as string);
  };
  return (
    <div css={MainMenuStyle.index("ct")}>
      <div className="menuArea ng-scope">
        <div className="mainMenu">
          <Link to={PATH.Home} className="logo">
            <img loading="lazy" src={"/common/desktop/logo.png"} alt="" />
          </Link>
          <div className="menu">
            <ul>
              {listMenu.map((item, index) => {
                const isActive = item.code === activeCode;
                //  const isActive = item.code === "FH";
                return (
                  <Fragment key={index}>
                    <li
                      onMouseLeave={() => setActiveCode(undefined)}
                      onMouseEnter={() => setActiveCode(item.code)}
                      className={`${isActive ? "hover" : ""}`}
                    >
                      <div
                        className={
                          item.path === PATH.promotion
                             ? "menuA_colorO"
                            : `menuA `
                        }
                        onClick={() => {
                          onClickItem(item);
                        }}
                      >
                        {menuNames[item.name] || item.name}
                      </div>
                      {item.code && (
                        <DropdownMenu isActive={isActive} menuItem={item} />
                      )}
                    </li>
                    {index < listMenu.length - 1 && (
                      <li className="line">
                        <span>|</span>
                      </li>
                    )}
                  </Fragment>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainMenu;
